module.exports = __webpack_public_path__ + "media/images/help-center/help-center-icon-game-accounts-d72667c215496cdc88c521daae9122b9.png";